<script>
import NavBar from '@components/nav-bar.vue'
import validTokenExists from '@utils/validTokenExists'
// import pbiService from '@services/powerbi.js'
import Cookies from 'js-cookie'

export default {
  components: { NavBar },
  computed: {
    embedInfo() {
      return this.$store.getters['users/embedInfo']
    },
    userRoles() {
      if (this.$store.getters['users/userRoles']) {
        return this.$store.getters['users/userRoles']
      } else return Cookies.get('userRoles')
    },
    userRepNum() {
      return this.$store.getters['users/userRepNum']
    },
  },
  async mounted() {
    if (
      this.$route &&
      this.$route.query &&
      this.$route.query.code &&
      this.$route.query.session_state
    ) {
      this.$store.commit('users/SET_AUTH_CODE', this.$route.query.code)
      this.$store.commit(
        'users/SET_SESSION_STATE',
        this.$route.query.session_state
      )
      await this.$store.dispatch('users/getToken')
    } else if (!validTokenExists()) {
      this.$store.dispatch('users/login')
    }
    if (!this.userRepNum) {
      this.repModal = true
    }
    // if (!this.embedInfo.token) {
    //   await pbiService.getEmbedInfo()
    // }
  },
}
</script>

<template>
  <div>
    <NavBar />
    <div :class="$style.container" class="test">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  // min-width: $size-content-width-min;
  // max-width: $size-content-width-max;
  // margin: 0 auto;
  height: 86vh;
}
.test {
  background-color: aqua;
}
</style>
